import React from "react";
import ReactDOM from "react-dom/client";
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import "@/index.css";
import "@/styles/tokens.css";
import "@/styles/tokens.dark.css";
import "@/styles/globals.css";
import App from "@/App";
import "@/styles/aesthetic.css";
import { registerServiceWorker } from "@/registerSW";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA — register service worker AFTER first paint to keep startup snappy.
registerServiceWorker({
  onUpdate: () => {
    window.dispatchEvent(new CustomEvent('polkdesq:sw-update'));
  },
});
